<template>
  <div class="bg-[#F7F7F7] p-8 max-w-full">
    <div class="flex flex-col max-w-6xl mx-auto">
      <h1 class="font-medium text-stone-700">Property Investment in Ghana</h1>
      <p class="py-3 text-xs leading-normal tracking-normal text-stone-600">
        Ghana after the launch of <i>‘The Year of Return’</i> by His Excellency
        the President of the Republic, has become one of the most visited and
        lived-in countries in the Western part of Africa. People come here for
        many reasons like investing, nationality switching, launching a new
        business, gathering with their families, or finding a peaceful-quality
        lifestyle. Others also come to learn the culture and experience the
        variety of food.
        <br />
        <br />
        Whatever your reason, buying a home in Ghana is a good decision on all
        levels. Ghana is made up of different regions, tribes and that means
        different cultures at which you will enjoy an ideal residential
        experience. Neighborhoods such as Cantonments, Labone, East Legon,
        Ridge, Dzorwulu, all located at Accra, are prime locations for luxury
        real estate, and they boast of quality infrastructure, good schools and
        world-class restaurants. Having a permanent home here ensures you a
        lavish and peaceful lifestyle with top services at your doorstep.
        <br />
        <br />
        Accra is undoubtedly the preferred choice for those looking for
        different job opportunities, vibrant communities, and great exposure for
        business needs. So, if you’re coming for a new job or want to open a new
        business, then Accra is a good spot. Not only is Accra the capital city
        but also a hub for fintech and many other ventures.
        <br />
        Kumasi is a good city for those who want to buy a property yet with
        affordable prices and seek a budget-friendly lifestyle.
      </p>
      <h1 class="font-medium text-stone-700">Ghana today</h1>
      <p class="py-3 text-xs leading-normal tracking-normal text-stone-600">
        Ghana, <i>‘Beyond the Return’</i> has been amazing with an incredible
        boost in the tourism industry as well as high demand for properties.
        <br />
        Buying property in Ghana is attractive not only to homebuyers and
        foreign nationals but also businessmen and investors. The West African
        country, Ghana, is the point where the interests of people from all over
        the world converge. The authorities are doing everything they can to
        attract foreign capital. The cost of property depends on the type of
        housing, size and location. Investing in real estate in Ghana is a wise
        decision and the greatest legacy you can ever leave your family.
      </p>
    </div>
  </div>
</template>
